import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Empty,
  Input,
  List,
  Pagination,
  Space,
  Typography,
} from 'antd';
import { PlusOutlined, SearchOutlined } from '@ant-design/icons';

import { PAGE_SIZE } from '../../services/cadastrosV2';
import './styles.css';

export function CadastroPage({
  title,
  newLabel,
  search,
  onSearch,
  loading,
  items,
  total,
  page,
  onPageChange,
  renderItem,
  onNew,
  extraFilters,
  searchPlaceholder,
}) {
  return (
    <main className="cadastros-v2-page">
      <header className="cadastros-v2-header">
        <div>
          <Typography.Title level={2}>{title}</Typography.Title>
          <Typography.Text type="secondary">
            Consulte, inclua e atualize registros sem sair da listagem.
          </Typography.Text>
        </div>
        <Button
          type="primary"
          size="large"
          icon={<PlusOutlined />}
          onClick={onNew}
        >
          {newLabel}
        </Button>
      </header>

      <section className="cadastros-v2-card">
        <div className="cadastros-v2-filters">
          <Input
            allowClear
            size="large"
            value={search}
            onChange={event => onSearch(event.target.value)}
            prefix={<SearchOutlined />}
            placeholder={
              searchPlaceholder || `Buscar ${title.toLowerCase()} por nome`
            }
            aria-label={
              searchPlaceholder || `Buscar ${title.toLowerCase()} por nome`
            }
          />
          {extraFilters}
        </div>

        <List
          className="cadastros-v2-list"
          loading={loading}
          dataSource={items}
          locale={{
            emptyText: <Empty description="Nenhum registro encontrado" />,
          }}
          renderItem={renderItem}
        />

        <Space
          className="cadastros-v2-pagination"
          direction="vertical"
          align="end"
        >
          <Pagination
            current={page}
            pageSize={PAGE_SIZE}
            total={total}
            hideOnSinglePage={total <= PAGE_SIZE}
            showSizeChanger={false}
            onChange={onPageChange}
            showTotal={value => `${value} registro${value === 1 ? '' : 's'}`}
          />
        </Space>
      </section>
    </main>
  );
}

CadastroPage.propTypes = {
  title: PropTypes.string.isRequired,
  newLabel: PropTypes.string.isRequired,
  search: PropTypes.string.isRequired,
  onSearch: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  total: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  renderItem: PropTypes.func.isRequired,
  onNew: PropTypes.func.isRequired,
  extraFilters: PropTypes.node,
  searchPlaceholder: PropTypes.string,
};

CadastroPage.defaultProps = {
  extraFilters: null,
  searchPlaceholder: null,
};
